// extracted by mini-css-extract-plugin
export var closeButton = "_k0-1";
export var closeX = "_k0-3";
export var container = "_k0-0";
export var image = "_k0-2";